import { useForm } from "@inertiajs/react"
import ErrorMessage from "./ErrorMessage"
import Button from "@/components/Button"
import useUser from "@/hooks/useUser"

const ChangeEmailForm = () => {
  const { user } = useUser()

  const {
    data,
    setData,
    post,
    resetAndClearErrors,
    processing,
    wasSuccessful,
    setError,
    errors,
  } = useForm({
    email: "",
  })

  const changeEmail = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (data.email === user?.email) {
      return setError("email", "Email is the same as your current email.")
    }

    post("/email_change", {
      async: true,
      preserveScroll: true,
      preserveState: true,
    })
  }

  if (wasSuccessful) {
    return (
      <div>
        <h2 className="text-lg font-semibold text-gray-900">Change email</h2>
        <div className="mt-3 overflow-hidden rounded-2xl border border-gray-100 bg-white shadow">
          <div className="px-4 pt-5 pb-6 sm:px-6">
            <p className="text-sm break-words text-gray-600">
              Confirmation emails were sent to <b>{user?.email}</b> and{" "}
              <b>{data.email}</b>. Please click the links in both emails to
              confirm the change.
            </p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <form onSubmit={changeEmail}>
      <h2 className="text-lg font-semibold text-gray-900">Change email</h2>
      <p className="mt-1 text-sm text-balance text-gray-500">
        Your current email address is <b>{user?.email}</b>. You can use the form
        below to change it. Confirmation emails will be sent to your current and
        new email addresses. Please click the links in both emails to confirm
        the change.
      </p>
      <div className="mt-3 overflow-hidden rounded-2xl border border-gray-100 bg-white shadow">
        <div className="px-4 pt-5 pb-6 sm:px-6">
          <label
            htmlFor="email"
            className="block pb-1.5 text-sm font-medium text-gray-700"
          >
            New email address
          </label>
          <input
            type="email"
            id="email"
            name="email"
            required
            className="focus:ring-chessdrop-600 block w-full rounded-xl border-0 p-3 text-gray-900 shadow-sm ring-1 ring-gray-300 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset"
            value={data.email}
            onChange={(e) => setData("email", e.target.value)}
          />
          <ErrorMessage className="mt-1.5" message={errors.email} />
        </div>

        <div className="flex items-center justify-end gap-x-3 border-t border-gray-200 px-4 py-4 sm:px-6">
          <Button
            type="button"
            style="secondary"
            onClick={() => resetAndClearErrors()}
            disabled={processing || !data.email}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            loading={processing}
            disabled={processing || !data.email}
          >
            Change email
          </Button>
        </div>
      </div>
    </form>
  )
}

export default ChangeEmailForm
